import {BrowserModule} from '@angular/platform-browser';
import {APP_ID, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MAT_DATE_LOCALE} from '@angular/material/core'; // MATERIAL_COMPATIBILITY_MODE
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent, PROGRESS_ID} from './app.component';
import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterialModule} from './shared/material-module';
import {NgProgressModule} from 'ngx-progressbar';
import {NgProgressHttpModule} from 'ngx-progressbar/http';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {ConfirmDialogModule} from './shared/confirm-dialog/confirm-dialog.module';

import {KeyboardShortcutsModule} from 'ng-keyboard-shortcuts';
import {FlatpickrModule} from 'angularx-flatpickr';
import {
  AddressOverrideConfirmDialogModule
} from './shared/address-override-confirm-dialog/address-override-confirm-dialog.module';
import {NgxTippyModule} from 'ngx-tippy-wrapper';
import {RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings} from 'ng-recaptcha';
import {ShowMenuInitializerService} from './shared/show-menu-initializer.service';
import {WhatsNewModule} from './whats-new/whats-new.module';
import {MatSpinnerOverlayModule} from "./viba/admin/content/mat-spinner-overlay/mat-spinner-overlay.module";
import {MatBadgeModule} from "@angular/material/badge";
import {MatTableModule} from "@angular/material/table";
import {MatSortModule} from "@angular/material/sort";


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

declare global {
  interface Window { dataLayer: any[]; }
}

@NgModule({ declarations: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        MaterialModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        TranslateModule,
        NgProgressModule.withConfig({
            spinner: false,
            color: '#004479',
            thick: true,
        }),
        NgProgressHttpModule.withConfig({
            id: PROGRESS_ID,
        }),
        ServiceWorkerModule.register('./sw.js', { enabled: environment.production }),
        MatSidenavModule,
        ConfirmDialogModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        AddressOverrideConfirmDialogModule,
        KeyboardShortcutsModule.forRoot(),
        FlatpickrModule.forRoot(),
        NgxTippyModule,
        MatSpinnerOverlayModule,
        MatBadgeModule,
        MatTableModule,
        MatSortModule,
        MatIconModule,
        WhatsNewModule], providers: [
        { provide: APP_ID, useValue: 'vision-angular' },
        { provide: MAT_DATE_LOCALE, useValue: 'en-Us' },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.captchaSiteKey,
            } as RecaptchaSettings,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (showMenuInitializer: ShowMenuInitializerService) => () => showMenuInitializer.initialize(),
            deps: [ShowMenuInitializerService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
